import { render, staticRenderFns } from "./TariffPlan.vue?vue&type=template&id=0ee22473&"
import script from "./TariffPlan.vue?vue&type=script&lang=js&"
export * from "./TariffPlan.vue?vue&type=script&lang=js&"
import style0 from "./TariffPlan.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports